import { render, staticRenderFns } from "./CampusSelectPopup.vue?vue&type=template&id=0b380528&scoped=true&lang=pug&"
import script from "./CampusSelectPopup.vue?vue&type=script&lang=js&"
export * from "./CampusSelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./CampusSelectPopup.vue?vue&type=style&index=0&id=0b380528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b380528",
  null
  
)

export default component.exports